<template>
  <div class="page-index">
    <div class="page-header">
      <div class="left">
        <a-icon class="menu" type="menu" />
        <img class="logo" src="@/assets/img/xomo.png" ></img>
        <div class="title">XOMO Presale</div>
      </div>
      <div class="right">
        <!-- <div class="primary" @click="handleConnectWallet"><a-icon class="icon" type="plus" />Create</div> -->
        <div class="gray" @click="handleConnectWallet(false)" v-if="walletConnected">{{ `BSC(${walletBNBBalance.toFixed(4)} BNB)` }}</div>
        <div class="primary" @click="handleConnectWallet(false)">{{ walletAccountShowName || 'Connect' }}</div>
      </div>
    </div>

    <div class="page-body">
      <div class="trend">
        <div class="tag">
          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
<path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M352 144h112v112"></path>
<path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M48 368l121.37-121.37a32 32 0 0145.26 0l50.74 50.74a32 32 0 0045.26 0L448 160"></path></svg>
          <div class="name">Trending</div>
        </div>
        <div class="token">
          <div class="item" v-for="(item, index) in trends">
            <span>#{{ index + 1 }}</span>
            <span class="key">{{ item }}</span>
          </div>
        </div>

      </div>

      <div class="project">
        <a-row class="row">
          <a-col :span="16">
            <a-card class="card project-wrap" :bordered="false">
              <div class="project-head">
                <img src="@/assets/img/xomo.png"/>
                <div class="data">
                  <div class="title">
                    <div class="name">
                      <span>XOMO Presale</span>
                      <div class="tags">
                        <a href="https://docs.pinksale.finance/important/kyc-and-audit-at-pinksale" class="tag1" target="_blank" >KYC</a>
                        <a href="https://github.com/interfinetwork/smart-contract-audits/blob/main/TLT_AuditReport_InterFi.pdf" class="tag2" target="_blank" style="background-color: rgb(0, 188, 212); color: rgb(255, 255, 255);">Audit</a>
                      </div>
                    </div>
                    <div class="state"></div>
                  </div>
                  <div class="media">
                    <a href="https://www.elvantis.com/" rel="nofollow noreferrer" target="_blank" class="mr-4 is-size-5">
                      <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                      </svg>
                    </a>
                    <a href="https://twitter.com/ElvantisGame" rel="nofollow noreferrer" target="_blank" class="mr-4 is-size-5">
                      <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
                      </svg>
                    </a>
                    <a href="https://t.me/ELVANTIS" rel="nofollow noreferrer" target="_blank" class="mr-4 is-size-5">
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path>
                      </svg>
										</a>
                    <!-- <a href="https://github.com/interfinetwork/smart-contract-audits/blob/main/Crypto2Card_0x0FB84e0f6732632dF6E597B385f15E101F7b02C3.pdf" rel="nofollow noreferrer" target="_blank" class="mr-4 is-size-5">
                      <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
                      </svg>
                    </a> -->
                  </div>
                  <div class="desc">The birth of Pandacoin XOMO, using Pandacoin as a medium to establish real economic links, let virtual currency be integrated into people's clothing, food, housing, and transportation, and facilitate the financial currency conversion. This is Pandacoin XOMO, we will start on this road first. This is my vision and my future.</div>
                </div>
              </div>
              <div class="project-data">
                <div class="line">
                  <div class="label">Presale Address</div>
                  <div class="value link primary" @click="handleSeeDetail(presaleAddress, 'address')">{{ presaleAddress }}</div>
                </div>
                <div class="line">
                  <div class="label">Token Name</div>
                  <div class="value">XOMO</div>
                </div>
                <div class="line">
                  <div class="label">Token Symbol</div>
                  <div class="value">XIONGMAO</div>
                </div>
                <div class="line">
                  <div class="label">Token Decimals</div>
                  <div class="value">16</div>
                </div>
                <div class="line">
                  <div class="label">Token Address</div>
                  <div class="value link primary" @click="handleSeeDetail(contractAddress, 'address')">
                    {{ contractAddress }} <br />
                    <div class="help">(Do not send ETH to the token address!)</div>
                  </div>
                </div>
                <div class="line">
                  <div class="label">Total Spply</div>
                  <div class="value">1,000,000,000,000,000 XOMO</div>
                </div>
                <div class="line">
                  <div class="label">Tokens For Presale</div>
                  <div class="value">20,000,000,000,000 XOMO</div>
                </div>
                <div class="line">
                  <div class="label">Tokens For Liquidity</div>
                  <div class="value">180,000,000,000,000 XOMO</div>
                </div>
                <div class="line">
                  <div class="label">Listing Rate</div>
                  <div class="value">1 BNB = {{ formatCurrency(presaleBNBRate) }} XOMO</div>
                </div>
                <div class="line">
                  <div class="label">Presale Rate</div>
                  <div class="value">1 BNB = {{ formatCurrency(presaleBNBRate) }} XOMO</div>
                </div>
                <div class="line">
                  <div class="label">Presale Start Time</div>
                  <div class="value">{{ moment(presaleStartTime).format('YYYY.MM.DD HH:mm') }} (UTC)</div>
                </div>
                <div class="line">
                  <div class="label">Presale End Time</div>
                  <div class="value">{{ moment(presaleEndTime).format('YYYY.MM.DD HH:mm') }} (UTC)</div>
                </div>
                <div class="line">
                  <div class="label">Listing On</div>
                  <div class="value">Pancakeswap</div>
                </div>
                <div class="line">
                  <div class="label">Liquidity Percent</div>
                  <div class="value">90%</div>
                </div>
                <div class="line">
                  <div class="label">Liquidity Lockup Time</div>
                  <div class="value">365 days after pool ends</div>
                </div>
              </div>
            </a-card>
          </a-col>
          <a-col :span="8">
            <a-card class="card pay-wrap" :bordered="false">
              <a-alert message="Make sure the website is xomo!" type="warning"></a-alert>
              <div class="countdown">
                <div class="tips">Presale Ends in:</div>
                <div class="times">
                  <span class="num day">{{ countdownData.d }}</span>
                  <span class="num hour">{{ countdownData.h }}</span>
                  <span class="num minute">{{ countdownData.m }}</span>
                  <span class="num second">{{ countdownData.s }}</span>
                </div>
              </div>
              <!-- <div class="eths">
                <a-progress stroke-linecap="square" :percent="75" :showInfo="false" :strokeColor="'rgb(72, 199, 116)'" style="height: 15px;" />
                <div class="ethnum">
                  <span class="current">192.62 ETH</span>
                  <span class="max">200 ETH</span>
                </div>
              </div> -->
              <div class="data">
                <span>Amount(max: {{ maxNum }} BNB)</span>
                <div class="control">
                  <a-input class="input" placeholder="0.0" v-model="inputNum" 
                  @change="e => handleInputNumChange(e,{num: 6, max: maxNum, min: minNum})">
                    <span slot="suffix"><b class="max" @click="() => inputNum = maxNum">MAX</b></span>
                  </a-input>
                </div>

                <a-button v-if="walletConnected" type="primary" @click="handleBuy(true)" :disabled="btnLoading">
                  <a-icon type="loading" v-if="btnLoading"></a-icon>
                  {{ buyBtnText }}
                </a-button>
                <a-button v-else type="primary" @click="handleConnectWallet(false)" :disabled="btnLoading">
                  <a-icon type="loading" v-if="btnLoading"></a-icon>
                  {{ buyBtnText }}
                </a-button>

                <div class="user-data" v-if="walletConnected">
                  <div class="current">Your XOMO: {{ formatCurrency(walletXOMOBalance) }}</div>
                  <div class="tx" v-if="recentTx" @click="handleSeeDetail(recentTx, 'tx')">
                    View Txn on BSCSCAN
                    <a-icon type="copy" @click.stop="handleCopy(recentTx)"></a-icon>
                  </div>
                </div>
              </div>
            </a-card>

            <a-card class="card" :bordered="false">
              <div class="line">
                  <div class="label">Status</div>
                  <div class="value primary">inprogress</div>
                </div>
                <div class="line">
                  <div class="label">Sale type</div>
                  <div class="value primary">Public</div>
                </div>
                <div class="line">
                  <div class="label">Minimum Buy</div>
                  <div class="value">{{ minNum }} BNB</div>
                </div>
                <div class="line">
                  <div class="label">Maximum Buy</div>
                  <div class="value">{{ maxNum }} BNB</div>
                </div>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </div>


    <div class="page-footer">
      Disclaimer: The information provided shall not in any way constitute a recommendation as to whether you should invest in any product discussed. We accept no liability for any loss occasioned to any person acting or refraining from action as a result of any material provided or published. © 2024 by XOMO team!
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import { contractAbi } from '@/assets/js/const'
import { formatCurrency, copyText } from '@/assets/js/util'

// const chainId = 97;
// const presaleAddress = '0xb1f83829f68ef44d74561ab59efc5c4ce6b97774'

const chainId = 56;
const presaleAddress = '0x43fbf652bb33d6c98f40913b0b614a9c3bce2bfd'
const presaleBNBRate = 380000000000
const contractAddress = '0xDfa4168f5482C8b805Daa57DEdF6BBF1A155409D'
const toAddress = '0xEfE80770B7BF28C6775Ba5321Ec779593eb63C9C'

// https://bscscan.com/address/0xDfa4168f5482C8b805Daa57DEdF6BBF1A155409D

export default {
    name: 'index',
    data() {
      return {
        trends: ['XOMO', 'BNB', 'opBNB', 'DODO', 'SHIB', 'BB', 'LISTA', 'YFI', 'IOTX', 'FEG', 'BAND', 'MONSTA' ],
        presaleAddress,
        contractAddress,
        presaleBNBRate,

        presaleStartTime: moment('2024-07-08 12:00:00'),
        presaleEndTime: moment('2024-10-08 12:00:00'),

        inputNum: '', // 输入的数量
        maxNum: 10,
        minNum: 0.0001,

        countdownData: {
          d: '0',
          h: '0',
          m: '0',
          s: '0'
        },

        walletWeb3: '',
        walletAccount: '',
        walletConnected: false,
        walletAccountShowName: '',

        walletBNBBalance: 0,
        walletXOMOBalance: 0,

        btnLoading: false,
        recentTx: ''
      }
    },
    computed: {
      ...mapState(['alreadyWalletConnected']),
      buyXOMO() {
        let xomo = 0;
        if(this.inputNum > 0) {
          xomo = this.inputNum * presaleBNBRate
        }
        return xomo
      },
      buyBtnText() {
        let text = 'Buy';
        if(!this.walletConnected) {
          text = 'Connect Wallet';
        }
        else {
          let xomo = this.buyXOMO;
          if(xomo > 0) {
            text = `Buy (${formatCurrency(xomo.toFixed())} XOMO)`
          }
          else if(this.btnLoading) {
            text = 'Connect...'
          }
        }
        return text;
      },
      btnDisabled() {
        
      }
    },
    mounted() {
      this.startDountdown();

      if(this.alreadyWalletConnected) {
        this.handleConnectWallet();
      }
    },
    methods: {
      ...mapActions(['setAlreadyWalletConnected']),
      moment,
      formatCurrency,
      startDountdown() {
        const self = this;
        setTimeout(() => {
          var nowDate = new Date();
          var diffTime = Math.round(Math.abs(new Date(self.presaleEndTime).getTime() - nowDate.getTime()) / 1000);
          var day = parseInt(diffTime / (60 * 60 * 24))
          var hours = parseInt(diffTime % (60 * 60 * 24) / (60 * 60))
          var minutes = parseInt(diffTime % (60 * 60) / 60)
          var seconds = parseInt(diffTime % 60);
          self.countdownData.d = day <= 9? `0${day}`:`${day}`;
          self.countdownData.h = hours <= 9? `0${hours}`:`${hours}`;
          self.countdownData.m = minutes <= 9? `0${minutes}`:`${minutes}`;
          self.countdownData.s = seconds <= 9? `0${seconds}`:`${seconds}`;

          self.startDountdown();
        }, 1000)
      },
      handleInputNumChange (e, { max = 100, min = 0 }) {
        // 控制输入
        let value = `${e.target.value}`
        value = value.replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1')
        if(!value || value <= 0) {
          e.target.value = value
          this.inputNum = value
          return;
        }
        if (value < min) {
          value = min
        }
        if (value > max) {
          value = max
        }
        e.target.value = value
        this.inputNum = value
      },
      handleCopy(value) {
        let result = copyText(value);
        if(result) {
          this.$message.success('Copied!');
        }
      },
      async handleConnectWallet(triggerBuy) {
        const self = this;
        if(!Web3) {
          self.message.info('please wait...');
          return;
        }

        if(self.btnLoading) {
          return;
        }

        if(!self.walletConnected) {
          self.btnLoading = true;
        }

        let web3Provider = null;
        console.log('[web3] getting provider...');
        // Modern Browsers like Chrome and Brave
        if (window.ethereum) {
          web3Provider = window.ethereum;
          try {
            // Request account access
            await window.ethereum.enable();
          } catch (error) {
            // User denied account access...
            alert('You must connect your metamask wallet !');
            console.error('User denied account access to metamask.');
            return;
          }
        } else {
          // you cant connect
          console.error('Unable to connect to metamask');
          alert(
            'You have to use Trustwallet or install Metamask to use this service, you can install it from :  https://metamask.io/download.html'
          );
          return;
        }

        let web3 = new Web3(web3Provider);
        let accounts = await web3.eth.getAccounts();
        self.walletAccount = accounts[0];
        self.walletAccountShowName = self.walletAccount.substr(0, 6) + '...' + self.walletAccount.slice(-4);
        self.walletConnected = true;
        self.setAlreadyWalletConnected(true);
        
        // 切换链 BNB链
        await web3Provider.request({
          method: 'wallet_switchEthereumChain',
          params: [{
            chainId: Web3.utils.numberToHex(chainId)
          }]
        })

        // BNB主网数据
        var bnbBalanceBig = await web3.eth.getBalance(self.walletAccount);
        var bnbBalance = Web3.utils.fromWei(bnbBalanceBig, 'ether')
        console.log('bnbbalance', bnbBalanceBig, bnbBalance)

        self.walletWeb3 = web3;
        self.walletBNBBalance = Number(bnbBalance);
        

        // XOMO数据
        // var xomoToken = new web3.eth.Contract(contractAbi, contractAddress);
        // var xomoBalanceBig = await xomoToken.methods.balanceOf(self.walletAccount).call();
        // var xomoBalance =  Web3.utils.fromWei(xomoBalanceBig, 'milli') / 10
        // console.log('xomobalance', xomoBalanceBig, xomoBalance)
        // self.walletXOMOBalance = xomoBalance;

        self.btnLoading = false;

        // 重新触发购买
        triggerBuy && self.handleBuy(true);
      },
      handleBuy(showAlert) {
        const self = this;
        if(self.btnLoading) {
          return;
        }

        if(!self.walletConnected) {
          self.handleConnectWallet(true);
          return;
        }
        if(!self.inputNum || self.inputNum <= 0) {
          showAlert && self.$message.warning('please input amount!');
          return;
        }
        if(self.inputNum > self.walletBNBBalance) {
          showAlert && self.$message.warning('insufficient balance, please supplement first!');
          return;
        }

        self.btnLoading = true;
        let amount = Web3.utils.toWei(self.inputNum, 'ether');

        self.walletWeb3.eth.sendTransaction({
          from: self.walletAccount,
          to: toAddress,
          value: amount,
          gas: 21000
        }).then(trans => {
          console.log('success', trans)
          self.btnLoading = false;

          self.recentTx = trans.blockHash;
        }).catch(err => {
          self.btnLoading = false;
          console.log('error', err)

          self.$message.warning(err.message)
        });
      },
      handleSeeDetail(value, type) {
        if(!value || !type) {
          return;
        }
        window.open(`https://bscscan.com/${type}/${value}`);
      }
    }
}
</script>

<style lang="less" scoped>
  .page-index {
    display: flex;
    flex-direction: column;
    background: #faf9fa;
    font-size: 16px;

    .page-header {
      height: 70px;
      background: #fff;
      padding: 0 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .left {
        width: 200px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .menu {
          font-size: 24px;
          margin-right: 10px;
        }

        .logo {
          width: 36px;
          height: 36px;
          margin-right: 10px;
          border-radius: 50%;;
        }

        .title {
          font-size: 16px;
          font-weight: 600;
        }
      }

      .right {
        display: flex;
        justify-content: flex-end;
        
        div {
          margin-left: 10px;
          cursor: pointer;

          background: #f3f3f4;
          color: #222;
          height: 40px;
          padding: 0 16px;
          box-shadow: none;
          border-radius: 16px;
          line-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;

          &.primary {
            background-color: #fdeaf1;
            color: #f95192;

            .icon {
              margin-right: 10px;
            }
          }
        }
      }
    }

    .page-body {
      display: flex;
      width: 100%;
      margin-top: 1px;
      flex-direction: column;

      .trend {
        background: #fff;
        padding: 0 30px;
        width: 100%;
        display: flex;
        align-items: center;

        .tag {
          display: flex;
          align-items: center;
          font-weight: 600;
          padding: 10px 0;

          svg {
            color: #f95192;
          }
          .name {
            margin-left: 10px;
          }
        }

        .token {
          display: flex;
          align-items: center;
          margin-left: 10px;

          .item {
            padding: 0 10px;
            font-size: 13px;

            &:first-child {
              font-weight: 500;
            }

            .key {
              color: #f95192;
              margin-left: 5px;
            }
          }
        }
      }

      .project {
        width: 1200px;
        margin: 0 auto;
        padding: 80px 0 10px 0;

        .card{
          margin: 0 10px;
          border: 1px solid #f0f0f0;
          border-radius: 4px;
          margin-bottom: 30px;

          .line {
            display: flex;
            justify-content: space-between;
            padding: 10px 0;
            color: #333;
            border-bottom: 1px solid #f0f0f0;

            .value {
              text-align: right;
              
              &.link {
                cursor: pointer;
              }
              
              &.primary {
                color: #f95192;
              }

              .help {
                font-size: 12px;
                color: #3298dc;
              }
            }
          }
        }

        .pay-wrap {
          .countdown {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .tips {
              margin-bottom: 5px;
              margin-top: 5px;
            }

            .times {
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              justify-content: center;

              .num {
                border-radius: 4px;
                padding: 8px 0;
                width: 37px;
                text-align: center;
                margin: 0 5px;
                font-size: 14px;
                font-weight: 700;
                color: #333;
                background-color: #feecf0 !important;
              }
            }
          }

          .eths {
            display: flex;
            flex-direction: column;

            .ethnum {
              display: flex;
              justify-content: space-between;
              margin-top: 10px;
              font-size: 12px;
            }
          }

          .data {
            display: flex;
            flex-direction: column;
            margin-top: 20px;
            font-weight: 500;
            color: rgba(0, 0, 0, .85);

            .control {
              margin-top: 2px;

              .max {
                color: #f95192;
                cursor: pointer;
                font-weight: 900;
                font-size: 16px;
              }
            }

            button {
              margin-top: 15px; 
              background: #f95192;
              border-color: #f95192;
            }

            .user-data {
              margin-top: 10px;
              color: #f95192;

              .tx {
                cursor: pointer;
              }
            }
          }
        }

        .project-wrap {
          .project-head {
            margin-bottom: 50px;
            display: flex;
            img {
              height: 64px;
              width: 64px;
              border-radius: 50%;
              margin-right: 20px;
            }
            .data {
              flex: 1;

              .title {
                margin-top: -5px;
                .name {
                  font-size: 26px;
                  font-weight: 600;
                  margin: 0;
                  display: flex;

                  .tags {
                    display: flex;
                    align-items: center;

                    a {
                      border-radius: 4px;
                      align-items: center;
                      font-size: 13px;
                      line-height: 1.5;
                      white-space: nowrap;
                      padding: 2px 8px;
                      background-color: #48c774;
                      color: #fff;
                      margin-left: 10px;
                    }
                  }
                }
              }

              .media {
                margin: -3px 0 2px 0;

                a {
                  color: #f95192;
                  cursor: pointer;
                  text-decoration: none;
                  font-size: 20px;
                  margin-right: 15px;
                }
              }

              .desc {
                color: rgba(0, 0, 0, .85);
                overflow-wrap: break-word;
              }
            }
          }
        }
      }
    }


    .page-footer {
      width: 75%;
      max-width: 900px;
      font-size: 15px;
      margin: 0 auto 4rem;
      text-align: center;
      margin-top: 50px;
    }
  }

  /deep/.ant-input:focus, /deep/.ant-input:hover, /deep/.ant-input:active {
    box-shadow: 0 0 0 2px rgba(249, 81, 146, .25) !important;
    border-color: #f95192 !important;
  }
  /deep/.ant-progress-bg {
    height: 15px !important;
    border-radius: 100px !important;
  }
</style>